import projectOptions from "src/shared/project-options";
import useFetch from "src/shared/hooks/useFetch";
import {
  fetchOptions,
  replayFetchOptions as videoFetchOptions,
} from "../highlightedProductSlice";
import { HighlightedProduct as HighlightedProductModel } from "../model/HighlightedProduct";
import deepCopy from "src/shared/util/deep-copy";
import isEmpty from "src/shared/util/is-empty";
import { useAppSelector } from "src/shared/hooks/redux";
import { StartStatuses } from "src/features/video/model/start-statuses";
import { videoStatusSelector } from "src/features/video/videoSlice";
import { useIsVideo } from "src/features/video/util/get-is-video";
import { useEffect, useState } from "react";
const productImageIndex = projectOptions.default.style.product.productImage;

const useHighlightedProduct = () => {
  const startStatus: StartStatuses = useAppSelector(videoStatusSelector);
  const getIsVideo = useIsVideo();
  const { eventId } = projectOptions.default.network;
  const products = useAppSelector((state) => state.products.list);
  const currentFetchOptions = getIsVideo() ? videoFetchOptions : fetchOptions;
  const [highlightedProducts, setHighlightedProducts] = useState<
    never[] | HighlightedProductModel[]
  >([]);
  const { data: _data } = useFetch<HighlightedProductModel[]>(
    currentFetchOptions,
    { eventId },
    { interval: 2000, deactivate: startStatus === StartStatuses.EXPIRED }
  );

  useEffect(() => {
    let highlightedProductsClone: HighlightedProductModel[] | never[] =
      !isEmpty(_data) ? deepCopy(_data) : [];

    highlightedProductsClone.forEach((product: HighlightedProductModel) => {
      const productDetail = products.find(
        (_product) => _product.productPk === product.omniweb_id
      );

      if (product?.productimage_set?.length > 0) {
        product.imageUrl =
          product?.productimage_set[productImageIndex]?.url ?? "";
      }

      if (!isEmpty(product)) {
        const percentage = Math.round(
          (+product.price / +product.retail_price) * 100
        );

        product.productDiscount = percentage > 0 ? "%" + percentage : "";
      }

      if (getIsVideo()) {
        product = { ...product, ...productDetail };
        productDetail?.productPrice &&
          (product.price = productDetail.productPrice);

        productDetail?.productImage &&
          (product.imageUrl = productDetail.productImage);
      }
    });

    setHighlightedProducts(highlightedProductsClone);
  }, [_data, products]);

  return { highlightedProducts };
};

export default useHighlightedProduct;
